import { IApplicationState } from '../../types/redux';
import { IExperiment } from '../../types/experiments';

export const selectExperiments = (state: IApplicationState): IExperiment[] => state.experiments;
